import { useQuery } from '@tanstack/react-query';

import type { UserShortDto } from '@/api/generated';

import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/util/useApiClient.util.ts';

type Response = UserShortDto[];

type Return = {
  isError: boolean;
  isGetting: boolean;
  users: Response;
};

export const useGetUsersShort = (): Return => {
  const { usersApi } = useApiClient();

  const { data, isError, isFetching } = useQuery<Response>({
    queryFn: async () => {
      const { data } = await usersApi.getUsersShort();
      return data.items;
    },
    queryKey: [QueryKeyEnum.USERS],
  });

  return {
    isError,
    isGetting: isFetching,
    users: data ?? [],
  };
};
